export default "__VITE_ASSET__C3HfAGI4__"